const state = {
    trackAndTrace: []
};

export default state
